var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"60%"}},[_c('ReportTableDashboard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }